import { AppRoutes } from "../../../constants";
import { UserRole } from "../../../types";

export interface ProfileMenuItem {
    label: string;
    path?: string;
    roles?: UserRole[];
    action?: "logout";
}

export const menuItems = [
    //admin menus
    {
        title: "Dashboard",
        path: AppRoutes.ADMIN.HOME,
        permission: [UserRole.SUPER_ADMIN],
    },
    {
        title: "NGOs",
        path: AppRoutes.ADMIN.NGO.LIST,
        permission: [UserRole.SUPER_ADMIN],
    },
    {
        title: "Cities",
        path: AppRoutes.ADMIN.CITY.LIST,
        permission: [UserRole.SUPER_ADMIN],
    },
    {
        title: "Categories",
        path: AppRoutes.ADMIN.CATEGORY,
        permission: [UserRole.SUPER_ADMIN],
    },
    {
        title: "Organizations",
        path: AppRoutes.ADMIN.ORGANIZATIONS.LIST,
        permission: [UserRole.SUPER_ADMIN],
    },


    //user menus
    {
        title: "Dashboard",
        path: AppRoutes.ORGANIZATION.HOME,
        permission: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    },
    {
        title: "Campaigns",
        path: AppRoutes.ORGANIZATION.CAMPAIGN.LIST,
        permission: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    },
    {
        title: "Donations",
        path: AppRoutes.ORGANIZATION.DONATIONS.LIST,
        permission: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    },
    // {
    //     title: "Reports",
    //     path: AppRoutes.ORGANIZATION.REPORT,
    //     permission: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    // },
    {
        title: "Members",
        path: AppRoutes.MEMBER.HOME,
        permission: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    },
    {
        title: "NGOs",
        path: AppRoutes.ORGANIZATION.NGOS,
        permission: [UserRole.ORGANIZATION_MEMBER],
    },
    {
        title: "Projects",
        path: AppRoutes.ORGANIZATION.PROJECTS.LIST,
        permission: [UserRole.NGO_MEMBER],
    },
    {
        title: "My Donation",
        path: AppRoutes.ORGANIZATION.MY_DONATION,
        permission: [UserRole.DONOR],
    },
];

export const profileMenuItems: ProfileMenuItem[] = [
    {
        label: "NGO Settings",
        path: AppRoutes.ORGANIZATION.SETTINGS,
        roles: [UserRole.NGO_MEMBER],
    },
    {
        label: "Users",
        path: AppRoutes.ORGANIZATION.ORG_MEMBER,
        roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
    },
    {
        label: "Organization Settings",
        path: AppRoutes.ORGANIZATION.SETTINGS,
        roles: [UserRole.ORGANIZATION_MEMBER],
    },
    {
        label: "User Setting",
        path: AppRoutes.ORGANIZATION.USER_SETTINGS,
        roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],

    },
    {
        label: "Reset Password",
        path: AppRoutes.ORGANIZATION.RESET_PASSWORD,
        roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER, UserRole.SUPER_ADMIN],
    },
    {
        label: "Logout",
        action: "logout",

    },
];
